import styles from "./AboutUs.module.scss";
import commonStyles from "../Common.module.scss";
import Ministers from "./Sections/Ministers";
import PhotoWall from "./Sections/PhotoWall";
import { Helmet } from "react-helmet-async";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>
          About Us | International Reformed Evangelical Church in Stockholm
        </title>
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta
          name="description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta
          name="keywords"
          content="international church stockholm, reformed church stockholm, evangelical church stockholm, IREC stockholm, PRII stockholm, protestant church, bible study stockholm, international church, church in stockholm, church in sweden, christian church stockholm, christian church sweden, sunday service stockholm, sunday service sweden"
        />
        <meta
          itemProp="description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta
          name="og:title"
          property="og:title"
          content="About Us | International Reformed Evangelical Church in Stockholm"
        />
        <meta
          name="og:description"
          property="og:description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta name="og:type" property="og:type" content="website" />
        <meta
          name="og:url"
          property="og:url"
          content="https://irec-stockholm.org/about-us"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Us | International Reformed Evangelical Church in Stockholm"
        />
        <meta
          name="twitter:description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English."
        />
        <meta
          name="og:image"
          property="og:image"
          content="https://irec-stockholm.org/mother_church.png"
        />
        <meta
          name="og:image:alt"
          property="og:image:alt"
          content="Mother Church - IREC Stockholm's main church building for Sunday worship and fellowship"
        />
        <meta name="og:image:width" property="og:image:width" content="1200" />
        <meta name="og:image:height" property="og:image:height" content="630" />
        <meta
          name="twitter:image"
          content="https://irec-stockholm.org/mother_church.png"
        />
        <link rel="canonical" href="https://irec-stockholm.org/about-us" />
      </Helmet>
      <div className={commonStyles.page}>
        <section className={styles.history} id="starting">
          <div className={styles.wrapper}>
            <h4>How it all started</h4>
            <h3>
              IREC Stockholm (aka. PRII Stockholm) was started in 2006 by Rev.
              Hendra Wijaya, who at that time was in Helsinki, Finland and was
              sent to serve in various branches in Germany, such as Berlin,
              Hamburg, and Munich.
            </h3>
            <p>
              The majority of the early congregations were women (around 6-7
              people) from various denominations who longed to have an
              Indonesian-speaking fellowship. Rev. Hendra visited once a month
              to teach the word of God with Reformed theology to the
              congregation in Stockholm. The congregation took turns in
              facilitating the fellowship in their homes.
            </p>
            <div
              className={styles.img}
              style={{
                backgroundImage: "url(mother_church.png)",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
          </div>
        </section>
        <section className={styles.history} id="later">
          <div className={styles.wrapper}>
            <h4>Fast forward</h4>
            <h3>
              When Rev. Hendra Wijaya returned to Singapore in 2007, Rev. Billy
              Kristanto continued his pastoral ministry to the congregations in
              Europe.
            </h3>
            <p>
              With the encouragement of God, IREC Stockholm held the meetings
              more often. Initially it was held once every month and then the
              frequency was increased to twice a month. Since 2018, fellowships
              have been held regularly once a week on Friday nights or Saturday
              mornings. IREC Stockholm’s inaugural Sunday service began on the
              first Sunday of 2019, precisely on January 6. And since, have
              continued to hold pastoral services in the form of Sunday service,
              Sunday school, Bible study, prayer meetings, fellowships, and
              more.
            </p>
          </div>
        </section>
        <PhotoWall />
        <Ministers />
        <section className={`${styles.history} ${styles.today}`} id="today">
          <div className={styles.wrapper}>
            <h4>And today</h4>
            <p>
              God has been faithful and sustains us through ups and downs.
              Rooted in Reformed theology and with the spirit to carry on
              evangelism, we pray that we will continue growing as a local
              church that becomes a blessing to the local community and welcomes
              people from all nations. With brothers and sisters in other IREC
              branches in Europe, we pray that the Kingdom of God advances here
              in truth and love.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
